import { PAGE_POSITIONS } from 'types';

import PinIcon from '~/assets/icons/Pin';
import RaffleIcon from '~/assets/icons/Raffle';
import Tracked from '~/components/Tracked';

import { SelectedView } from './index';

type Props = {
  selectedView: SelectedView;
  setSelectedView: React.Dispatch<React.SetStateAction<SelectedView>>;
};

const ViewToggle = ({ selectedView, setSelectedView }: Props) => {
  const { RAFFLES, RETAILERS } = SelectedView;

  return (
    <div className="flex gap-2 p-4">
      <Tracked.Button
        onClick={() => setSelectedView(RETAILERS)}
        className={
          selectedView === RETAILERS
            ? 'rounded-3xl bg-black text-white'
            : 'rounded-3xl font-normal'
        }
        variant="transparent-black-border"
        name="WTB_VIEW_TOGGLE_RETAILERS"
        pagePosition={PAGE_POSITIONS.wtb}
      >
        <div className="flex items-center justify-center gap-1">
          <PinIcon
            stroke={selectedView === RETAILERS ? 'white' : 'black'}
            width="24"
            height="24"
          />
          <p>Retailers</p>
        </div>
      </Tracked.Button>
      <Tracked.Button
        onClick={() => setSelectedView(RAFFLES)}
        className={
          selectedView === RAFFLES
            ? 'rounded-3xl bg-black text-white'
            : 'rounded-3xl font-normal'
        }
        pagePosition={PAGE_POSITIONS.wtb}
        name="WTB_VIEW_TOGGLE_RAFFLES"
        variant="transparent-black-border"
      >
        <div
          data-cy="raffle-toggle-button"
          className="flex items-center justify-center gap-1"
        >
          <RaffleIcon
            fill={selectedView === RAFFLES ? 'white' : 'black'}
            width="24"
            height="24"
          />
          <p>Raffles</p>
        </div>
      </Tracked.Button>
    </div>
  );
};

export default ViewToggle;
